import { render } from "./ShiftView.vue?vue&type=template&id=a97fe926"
import script from "./ShiftView.vue?vue&type=script&lang=js"
export * from "./ShiftView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__